import { __assign, __awaiter, __generator } from "tslib";
import { AuthTypeEnum, setApiKeyToObject, setSearchParams, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, serializeDataIfNeeded, toPathString } from "./common";
import globalAxios from 'axios';
/**
 * Base API to store config, basepath and axios instance.
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    /**
     * Constructor to create baseAPI.
     * @param { string } basePath basePath of api requests.
     * @param { { axios: AxiosInstance, configuration: Configuration } } config to be passed down to axios.
     */
    function BaseAPI(basePath, config) {
        if (config === void 0) { config = { axios: globalAxios }; }
        this.basePath = basePath;
        this.axios = config.axios;
        if (config.configuration) {
            this.configuration = config.configuration;
            this.basePath = config.configuration.basePath || this.basePath;
        }
    }
    BaseAPI.prototype.authConfig = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var localVarQueryParameter, localVarHeaderParameter, localVarHeaderParameter, localVarHeaderParameter;
            var authType = _b.authType, urlObj = _b.urlObj, options = _b.options, authKey = _b.authKey;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(authType === AuthTypeEnum.InQuery && typeof authKey === 'string')) return [3 /*break*/, 2];
                        localVarQueryParameter = {};
                        return [4 /*yield*/, setApiKeyToObject(localVarQueryParameter, authKey, this.configuration)];
                    case 1:
                        _c.sent();
                        setSearchParams(urlObj, localVarQueryParameter);
                        return [3 /*break*/, 9];
                    case 2:
                        if (!(authType === AuthTypeEnum.InHeader && typeof authKey === 'string')) return [3 /*break*/, 4];
                        localVarHeaderParameter = {};
                        return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, authKey, this.configuration)];
                    case 3:
                        _c.sent();
                        options.headers = __assign(__assign({}, options.headers), localVarHeaderParameter);
                        return [3 /*break*/, 9];
                    case 4:
                        if (!(authType === AuthTypeEnum.Basic)) return [3 /*break*/, 5];
                        setBasicAuthToObject(options, this.configuration);
                        return [3 /*break*/, 9];
                    case 5:
                        if (!(authType === AuthTypeEnum.Bearer)) return [3 /*break*/, 7];
                        localVarHeaderParameter = {};
                        return [4 /*yield*/, setBearerAuthToObject(localVarHeaderParameter, this.configuration)];
                    case 6:
                        _c.sent();
                        options.headers = __assign(__assign({}, options.headers), localVarHeaderParameter);
                        return [3 /*break*/, 9];
                    case 7:
                        if (!(authType === AuthTypeEnum.Oauth)) return [3 /*break*/, 9];
                        localVarHeaderParameter = {};
                        return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, authKey[0], authKey[1], this.configuration)];
                    case 8:
                        _c.sent();
                        options.headers = __assign(__assign({}, options.headers), localVarHeaderParameter);
                        _c.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Send axios request
    * @param {Promise<RequestArgs>} request to be send trough axios.
    * @param {AxiosInstance} axios optional axios instance.
    * @returns {Promise<AxiosResponse<T>>} promisable axios response.
    */
    BaseAPI.prototype.sendRequest = function (request, axios, basePath) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, auth, urlObj, options, serializeData, axiosRequestArgs;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, request];
                    case 1:
                        _a = _b.sent(), auth = _a.auth, urlObj = _a.urlObj, options = _a.options, serializeData = _a.serializeData;
                        auth === null || auth === void 0 ? void 0 : auth.forEach(function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
                            var authType = _b.authType, authKey = _b.authKey;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, this.authConfig({ authType: authType, urlObj: urlObj, options: options, authKey: authKey })];
                                    case 1:
                                        _c.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        if (serializeData) {
                            options.data = serializeDataIfNeeded(serializeData, options, this.configuration);
                        }
                        axiosRequestArgs = __assign(__assign({}, options), { url: (this.basePath || basePath) + toPathString(urlObj) });
                        return [2 /*return*/, (axios || this.axios).request(axiosRequestArgs)];
                }
            });
        });
    };
    return BaseAPI;
}());
export { BaseAPI };
;
//# sourceMappingURL=base.js.map